module.exports = __webpack_public_path__ + "static/media/pousada_10.f28618aa.jpg";